import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [], // Array of items in the cart
    totalPrice: 0,
  },
  reducers: {
    addCart: (state, action) => {

      const {productID, quantity, total, name, number, size,  } = action.payload; 
      
      const toIncrementItem = state.items.find(item =>
        item.productID.toString() === productID.toString() &&
        item.name === name &&
        item.number.toString() === number.toString() && 
        item.size === size
    );
      if (toIncrementItem) {

        toIncrementItem.quantity += quantity;
        state.totalPrice+=total;

        ///////////////

      const tempprice = toIncrementItem.price.replace(/,/g, ''); // Convert the string to an integer
      const intPrice = parseInt(tempprice, 10); // Convert the string to an integer
      const totalPrice = toIncrementItem.quantity * intPrice; // Calculate the total price for this item  
        toIncrementItem.subtotal=totalPrice.toLocaleString();
      }
      else {

        const { total, ...rest } = action.payload; // Destructure price and total
        state.items.push(rest); // Add the new item to the items array
        state.totalPrice += total; // Update total price separately 
      }
      
      // console.log('Existing items:', [...state.items]);
      state.items.forEach((item, index) => {
        // console.log(`Item ${index + 1}:`, JSON.parse(JSON.stringify(item)));
        // console.log('Item ID=',item.id);
      });
      
    },
    deleteCart: (state, action) => {
      const { id } = action.payload;

      // Find the item to delete
      const toDeleteItem = state.items.find((item) => item.id === id);

      const tempprice = toDeleteItem.price.replace(/,/g, ''); // Convert the string to an integer
      const intPrice = parseInt(tempprice, 10); // Convert the string to an integer
      const totalPrice = toDeleteItem.quantity * intPrice; // Calculate the total price for this item  

      // Reduce the total price by the amount of the item being deleted
      state.totalPrice -= totalPrice;

      // Update items, removing the item with the matching ID
      state.items = state.items.filter((item) => item.id !== id);
    },
    deleteAllCart: (state) => {
      return {
        ...state,
        items: [],
        totalPrice: 0,
      };
    }
    
  },

});

export const { addCart, deleteCart, deleteAllCart } = cartSlice.actions;
export default cartSlice.reducer; 